"use client"

import { useState } from "react"
import { X } from "lucide-react"

const districts = [
  "Ampara", "Anuradhapura", "Badulla", "Batticaloa", "Colombo",
  "Galle", "Gampaha", "Hambantota", "Jaffna", "Kalutara",
  "Kandy", "Kegalle", "Kilinochchi", "Kurunegala", "Mannar",
  "Matale", "Matara", "Monaragala", "Mullaitivu", "Nuwara Eliya",
  "Polonnaruwa", "Puttalam", "Ratnapura", "Trincomalee", "Vavuniya"
]

const CourierModal = ({ onClose, onSubmit, initialData = null }) => {
  const [formData, setFormData] = useState({
    name: initialData?.name || "",
    contact: initialData?.contact || "",
    fees: initialData?.fees || {}
  })

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleFeeChange = (district, value) => {
    setFormData((prev) => ({
      ...prev,
      fees: {
        ...prev.fees,
        [district]: value
      }
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const { name, contact } = formData
    if (!name || !contact) {
      setError("Courier Name and Contact are required")
      return
    }

    setLoading(true)
    const success = await onSubmit(formData)
    setLoading(false)
    if (success) onClose()
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl">
        <div className="flex justify-between items-center p-6 border-b">
          <h3 className="text-lg font-medium text-gray-900">{initialData ? "Edit Courier" : "Add Courier"}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500 focus:outline-none">
            <X className="h-6 w-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          {error && <div className="mb-4 bg-red-100 border border-red-400 text-red-700 px-4 py-2 rounded">{error}</div>}

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Courier Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 text-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Contact Number</label>
              <input
                type="text"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-md p-2 text-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Shipping Fees by District</label>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 max-h-[400px] overflow-y-auto">
                {districts.map((district) => (
                  <div key={district}>
                    <label className="text-sm text-gray-600">{district}</label>
                    <input
                      type="number"
                      min="0"
                      value={formData.fees[district] || ""}
                      onChange={(e) => handleFeeChange(district, e.target.value)}
                      className="w-full border border-gray-300 rounded-md p-2 text-sm mt-1"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 bg-white hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 disabled:opacity-50"
            >
              {loading ? "Saving..." : initialData ? "Update Courier" : "Save Courier"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default CourierModal
